import { render, staticRenderFns } from "./MdMemo.vue?vue&type=template&id=77d196cf&scoped=true&"
import script from "./MdMemo.vue?vue&type=script&lang=js&"
export * from "./MdMemo.vue?vue&type=script&lang=js&"
import style0 from "./MdMemo.vue?vue&type=style&index=0&id=77d196cf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d196cf",
  null
  
)

export default component.exports